<template lang="pug">
teleport(to="body" :disabled="!fullscreen")
	.v-loader.loader(:class="{'loader--active': loading, 'loader--fullscreen': fullscreen}")
		.loader__container
			transition(name="fade")
				.loader__content(v-if="loading")
					.loader__spinner
						svg.loader__ring.loader__ring--outer(xmlns="http://www.w3.org/2000/svg" viewBox="0 0 50 50")
							circle.loader__track(cx="25" cy="25" r="21" fill="none")
							circle.loader__arc(cx="25" cy="25" r="21" fill="none")
						svg.loader__ring.loader__ring--inner(xmlns="http://www.w3.org/2000/svg" viewBox="0 0 50 50")
							circle.loader__track(cx="25" cy="25" r="12" fill="none")
							circle.loader__arc(cx="25" cy="25" r="12" fill="none")
					.loader__progress(v-if="progress !== null")
						.loader__progress-text(v-if="progressText") {{ progressText }}
						.loader__progress-track
							.loader__progress-value(:style="{width: `${normalizedProgress}%`}")
						.loader__progress-percent {{ normalizedProgress }}%
</template>

<script>
export default {
	props: {
		loading: {
			type: Boolean,
			default: false
		},
		// Центрировать спиннер по центру экрана (телепорт в body),
		// а не по центру родительского блока. Нужно для полноэкранных
		// засветлителей (например, форма размещения объявления), где
		// position: fixed внутри блока ломается transform-предками.
		fullscreen: {
			type: Boolean,
			default: false
		},
		progress: {
			type: Number,
			default: null
		},
		progressText: {
			type: String,
			default: ''
		}
	},
	computed: {
		normalizedProgress() {
			return Math.max(0, Math.min(100, Math.round(Number(this.progress) || 0)));
		}
	}
};
</script>
